var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VAppLayout',[_c('VPageHeader',{attrs:{"title":_vm.$t('nav.review.title')}}),_c('VContainer',[_c('VReviewAdd',{attrs:{"is-restaurant-logo-visible":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }